module.exports = __webpack_public_path__ + "img/digitale-prozessoptimierung-fuer-energieversorger.3c46b622.jpg";